import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ContentService } from '../../services/content.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { Location } from '@angular/common';
import { FilterDataService } from '../../services/filter-data.service';
import { AnalyticsService } from '../../services/analytics.service';
import { FeedbackService } from '../../services/feedback.service';
import { StorageKey, StorageService } from '../../services/storage.service';
import { SingleResponse } from '../../models/Strapi';
import { Mission } from '../../models/Missions';
import { Rating } from '../../types/rating';

@Component({
    selector: 'app-mission-card-detail',
    templateUrl: './mission-card-detail.component.html',
    styleUrls: ['./mission-card-detail.component.scss'],
    standalone: false
})
export class MissionCardDetailComponent implements OnInit {
  @ViewChild('audio') audio: ElementRef<HTMLAudioElement>;
  @Input() backgroundUrl = 'blurred-spring-background.svg';

  missionId: number;
  mission: SingleResponse<Mission>;
  env = environment;
  youtubeEmbed = '';
  rating?: Rating | null;

  isRatingMission = false;
  isLoadingRating = true;

  constructor(
    public filterDataService: FilterDataService,
    private contentService: ContentService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private analyticsDataService: AnalyticsService,
    protected feedbackService: FeedbackService,
    private storageService: StorageService,
  ) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe(async (params) => {
      if (params) {
        this.missionId = Number(params['mission']);
        await Promise.all([this.analyticsDataService.viewMission(this.missionId), this.loadRating()]);
      }
    });

    this.contentService.getMissionById(this.missionId).subscribe((r) => {
      this.mission = r;
      this.youtubeEmbed = this.filterDataService.youtubeIntoEmbedLink(r.data.attributes.videoUrl);
    });
  }

  goBack() {
    this.location.back();
  }

  toggleAudio() {
    if (this.audio.nativeElement.paused) this.audio.nativeElement.play().then();
    else this.audio.nativeElement.pause();
  }

  finishMission() {
    this.filterDataService.finishMission(this.missionId);
    this.goBack();
    return this.analyticsDataService.missionFinished(this.missionId);
  }

  updateMissionsTodayCount() {
    const missionsFinishedToday = this.storageService.get(StorageKey.MISSIONS_FINISHED_TODAY);
    this.storageService.set(StorageKey.MISSIONS_FINISHED_TODAY, missionsFinishedToday ? missionsFinishedToday + 1 : 1);
  }

  async loadRating() {
    this.isLoadingRating = true;
    this.rating = await this.feedbackService.getMissionRating(this.missionId);
    this.isLoadingRating = false;
  }

  async rateMission(number: number) {
    try {
      this.isRatingMission = true;
      await this.feedbackService.rateMission(this.missionId, number);
      await this.loadRating();
    } finally {
      this.isRatingMission = false;
    }
  }
}
